import React, {useState} from 'react';
import {
    Col,
    Row
} from 'reactstrap';

import {ButtonNew} from "../../../components/buttons/buttonsActions";
import AmenityTypeList from "./_list";
import AmenityTypeForm from "./_form";

export default function AmenityType() {
    const [editMode, setEditMode] = useState(false);
    const [item, setItem] = useState();

    // Modo de vista: LIST, FORM
    const [viewMode, setViewMode] = useState("LIST")

    const setForm = (editModeP, data, viewModeP) => {
        setEditMode(editModeP ? editModeP : editMode);
        setItem(data);
        setViewMode(viewModeP ? viewModeP : "LIST")
    }

    const updateItem = (item) => {
        setItem(item)
    }

    return (
        <div>
            {/*--------------------------------------------------------------------------------*/}
            {/* Header*/}
            {/*--------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        {
                            viewMode === "LIST" ?
                                <div className="ml-auto paddingAdd">
                                    <ButtonNew onClick={() => setForm(null, null, "FORM")}/>
                                </div> : null
                        }
                    </div>
                </Col>
            </Row>
            {(
                function() {
                    switch (viewMode) {
                        case "LIST" :
                            return (
                                <Row>
                                    <Col md="12">
                                        <AmenityTypeList setForm={setForm} />
                                    </Col>
                                </Row>
                            );
                        case "FORM" :
                            return (
                                <Row>
                                    <Col md="12">
                                        <AmenityTypeForm setForm={setForm} updateItem={updateItem} item={item} editMode={editMode} />
                                    </Col>
                                </Row>
                            );
                        default:
                            return null;
                    }
                })()}
        </div>
    );
}